import { getCopyText } from "lib/getCopyText"
import useCurrent from "lib/use-current"

export const getSessionCopyText = (current: Exclude<ReturnType<typeof useCurrent>, undefined>) => {
  return getCopyText(current.config.session_copy_text)
}
